import { useNavigate, useParams } from "react-router-dom"
const token = "testinggeneratetoken"; //openai
export const withHooks=(Component) => {
    return props => <Component {...props} params={useParams()} navigate={useNavigate()} />
}